import axios from 'axios';
import { API_END_POINT } from '../configs/configs';

 

class Auth { 
    currentUser = {};
    isSignIn = false;
    getToken(){
        const jwtToken =  localStorage.getItem('jwt_token'); 
        return jwtToken;
    }
    saveToken(token){
        localStorage.setItem('jwt_token', token);
    }
    async init(){
        try { 
            let token = this.getToken();
            let response = await axios({ 
                // Endpoint to send files
                url: API_END_POINT.IS_AUTH,
                method: 'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    // Add any auth token here
                    authorization: `Bearer ${token}`,
                 },  
            }); 
            let data = response.data;
            if(data['error']){
                return Promise.reject(data.message);
            }
   
            this.isSignIn = true; 
            this.currentUser = data;
            return Promise.resolve(true);
        }catch(error){ 
            return Promise.reject(error.response.data.message);
        }
    }
    async singIn(email, password){
        try {  
            let response = await axios({ 
                // Endpoint to send files
                url: API_END_POINT.SIGN_IN,
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    // Add any auth token here
                    authorization: 'your token comes here',
                 }, 
                // Attaching the data
                data: {
                    email: email,
                    password: password,
                },
            }); 
            let data = response.data;
            if(data['error'] != 0){
                return Promise.reject(data.message);
            }
            let results = data['results'];
            this.saveToken(results['token']);
            this.currentUser = results['user'];
            console.log(results['user']);
            this.isSignIn = true;
            return Promise.resolve(true);
        }catch(error){ 
            return Promise.reject(error.response.data.message);
        }
    }
    async signOut(){
        try {  
            let token = this.getToken(); 
            let response = await axios({ 
                // Endpoint to send files
                url: API_END_POINT.SIGN_OUT,
                method: 'POST', 
                 headers: { 
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${token}`,
                 }, 
                // Attaching the data
                data: {
                    token: token,
                    email: this.currentUser['user_email'],
                },
            }); 
            let data = response.data;
            if(data['error'] != 0){
                return Promise.reject(data.message);
            } 
            this.saveToken('');
            this.isSignIn = false;
            return Promise.resolve(true);
        }catch(error){ 
            return Promise.reject(error.response.data.message);
        }
    }
    async forgotPassword(email){
        try {   
            let response = await axios({ 
                // Endpoint to send files
                url: API_END_POINT.FORGOT_PASSWORD,
                method: 'POST', 
                 headers: { 
                    'Content-Type': 'application/json', 
                 }, 
                // Attaching the data
                data: {
                    email: email,
                },
            }); 
            let data = response.data;
            if(data['error'] != 0){
                return Promise.reject(data.message);
            }  
            return Promise.resolve(true);
        }catch(error){ 
            return Promise.reject(error.response.data.message);
        }
    }
    async verifyForgotPassword(email, code, newPassword){
        try {
            let response = await axios({ 
                // Endpoint to send files
                url: API_END_POINT.VERIFY_FORGOT_PASSWROD,
                method: 'POST', 
                 headers: { 
                    'Content-Type': 'application/json', 
                 },
                data: {
                    email: email,
                    code: code, 
                    new_password: newPassword
                },
            }); 
            let data = response.data;
            if(data['error'] != 0){
                return Promise.reject(data.message);
            }
            let results = data['results'];
            this.saveToken(results['token']);
            this.isSignIn = true;
            return Promise.resolve(true);
        }catch(error){ 
            return Promise.reject(error.response.data);
        }
    }

    async ChangePassword({old_password,new_password}){
        try {
            let currentUserToken = this.getToken();
            let response = await axios({
              // Endpoint to send files
              url: API_END_POINT.CHANGE_PASSWORD,
              method: 'POST',
              data: { old_password ,new_password },
              headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${currentUserToken}`,
              },
            });
           
            if ((Number(response.data.error) !== 0 && response.data.error!== undefined) || response.data.errors) {
              return Promise.reject(response.data);
            }
            return Promise.resolve(response.data.results);
          } catch (error) {
            return Promise.reject(error);
          }
    }
}
let AuthUser = new Auth();
export default AuthUser;